<template>
    <div class="loading-spinner" v-if="isLoading">
        <base-spinner></base-spinner>
    </div>
    <div class="validity" v-else>       
        <template v-if="itemLists.length>0">
            <div class="item_box" v-for="(item, index) in itemLists" :key="index">
                <div class="item_head"><h1>{{item.item_title}}</h1></div>
                <div class="limit" v-if="item.limit_date">유효기간
                    <div class="remain"><display-time :time="item.limit_date" :type="1" /></div>
                </div>
                 <div class="limit" v-else>유효갯수
                    <div class="remain">{{item.limit_count}}</div>
                </div>
            </div>
        </template>

        <template  v-else>
            <div class="no_item">
                이용중인 아이템이 없습니다.
            </div>            
        </template>
    </div>
</template>
<script>
import { myItemValidity } from '@/components/mixins/pages/myItemValidity.js'
export default {
    name:'mobile_myItemValidity',
    props:[
        
    ],
    data(){
        return{

        }
    },
    mixins:[
        myItemValidity
    ],
    components:{

    },
    mounted() {
    },
    methods:{
    }
}
</script>
<style lang="scss" scoped>
.validity{    
    display:flex;
    flex-wrap:wrap;    
    padding:10px;
    .no_item{text-align:center}
    .item_box{
        box-shadow: 0 10px 15px -3px rgba(0,0,0,.1),0 4px 6px -2px rgba(0,0,0,.05);
        width: 50%;
        overflow: hidden;
        margin: 0.5rem;
        border-radius: .5rem;
        background-color: #fff;
        border:1px solid #e0e0e0;
        .item_head{
            padding-left: 1rem;
            padding-right: 1rem;
            padding-top: 1rem;
            padding-bottom: 1rem;
            h1{
                font-size: 1rem;
                color: #1a202c;
                font-weight: 700;
                margin: 0;
                text-align:center;
            }            
        }
        .limit{
            background-color: #1a202c;
            color:#bae8e8;
            text-align:center;
            padding:10px;
            .remain{
                background-color: #399372;  
                border-radius:5px; 
                padding-bottom:5px;
                margin-top:10px; 
                font-size:14px;
                color:#fff;
                font-weight:bold;
            }
            .datetype01{
                color:#fff !important;   
            }
        }
    }
}
</style>